import { getPricingsByAgentId, Pricing } from '@nemuru-eng/js-api-client';

export class GetPricingsService {
  private static instance: GetPricingsService;
  private agentId: string | null = null;
  public pricings: Pricing[] | null = null;

  constructor() {}

  public static getInstance() {
    if (!GetPricingsService.instance) {
      GetPricingsService.instance = new GetPricingsService();
    }
    return GetPricingsService.instance;
  }

  public async execute(agentId: string): Promise<Pricing[]> {
    if (this.pricings && this.agentId === agentId) {
      return this.pricings;
    }
    const pricings = await getPricingsByAgentId({ agentId });
    this.pricings = pricings;
    this.agentId = agentId;
    return pricings;
  }
}
